import { createSlice } from "@reduxjs/toolkit";
import { recommendCandidate, comparisonKey } from "../actions/candidate-comparison-actions";

const initialState = {
  byKey: {},
  loadingByKey: {},
  error: null,
};

const candidateComparisonSlice = createSlice({
  name: "candidateComparison",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(recommendCandidate.pending, (state, action) => {
        const k = comparisonKey(action.meta.arg.interviewId, action.meta.arg.userIds);
        state.loadingByKey[k] = true;
      })
      .addCase(recommendCandidate.fulfilled, (state, action) => {
        const { key, data } = action.payload;
        state.loadingByKey[key] = false;
        state.byKey[key] = data;
      })
      .addCase(recommendCandidate.rejected, (state, action) => {
        const k = comparisonKey(action.meta.arg.interviewId, action.meta.arg.userIds);
        state.loadingByKey[k] = false;
        state.error = action.payload;
      });
  },
});

const candidateComparisonSliceReducer = candidateComparisonSlice.reducer;
export default candidateComparisonSliceReducer;
